export enum ObjectEvent {
	BEFORE_DELETE = 'beforeDelete',
}

export const ON_OBJECT_BEFORE_DELETE = {type: ObjectEvent.BEFORE_DELETE};
